import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserRole } from './user-roles';
import { environment } from '../environments/environment';
 
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
	baseUrl = environment.baseUrl;
  private userRolesUrl = this.baseUrl +'/api/userRoles';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getUserRoles (): Observable<UserRole[]> {
    return this.http.get<UserRole[]>(this.userRolesUrl)
  }
 
  getUserRole(id: number): Observable<UserRole> {
    const url = `${this.userRolesUrl}/${id}`;
    return this.http.get<UserRole>(url);
  }
 
  addUserRole (userRole: UserRole): Observable<UserRole> {
    return this.http.post<UserRole>(this.userRolesUrl, userRole, httpOptions);
  }
 
  deleteUserRole (userRole: UserRole | number): Observable<UserRole> {
    const id = typeof userRole === 'number' ? userRole : userRole.userroletypeid;
    const url = `${this.userRolesUrl}/${id}`;
 
    return this.http.delete<UserRole>(url, httpOptions);
  }
 
  updateUserRole (userRole: UserRole): Observable<any> {
    return this.http.put(this.userRolesUrl, userRole, httpOptions);
  }
}